import { render, staticRenderFns } from "./usaReview.vue?vue&type=template&id=31a12bf5&"
import script from "./usaReview.vue?vue&type=script&lang=js&"
export * from "./usaReview.vue?vue&type=script&lang=js&"
import style0 from "./usaReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports